import React from 'react';
import { useExam } from './ExamContext';

/**
 * QuestionPalette: Renders interactive navigation buttons for questions.
 * Robustly handles multiple ID schemas (questionId, id) and display values (number, extracted index).
 */
const QuestionPalette = ({ questions, onJumpToQuestion }) => {
  const { answers, flags = [] } = useExam();

  if (!questions || questions.length === 0) return null;

  return (
    <div className="question-palette-container" style={{ marginBottom: '20px' }}>
      <h5 style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#333' }}>Question Navigation</h5>
      <div 
        className="question-palette" 
        style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(5, 1fr)', 
          gap: '6px', 
          padding: '10px', 
          background: '#fcfcfc', 
          border: '1px solid #e0e0e0',
          borderRadius: '4px'
        }}
      >
        {questions.map((q, idx) => {
          const qId = q.questionId || q.id || `Q${idx + 1}`;
          const qNum = q.number || (String(qId).match(/\d+/) ? parseInt(String(qId).match(/\d+/)[0], 10) : idx + 1);
          
          const isAnswered = !!answers[qId];
          const isFlagged = flags.includes(qId);
          
          return (
            <button
              key={qId}
              onClick={() => onJumpToQuestion && onJumpToQuestion(qId)}
              style={{
                padding: '8px 4px',
                fontSize: '0.85rem',
                fontWeight: 'bold',
                backgroundColor: isAnswered ? '#28a745' : '#f8f9fa',
                color: isAnswered ? '#fff' : '#333',
                border: isFlagged ? '2px solid #ffc107' : '1px solid #ccc',
                borderRadius: '3px',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              title={`Question ${qNum}${isAnswered ? ' (Answered)' : ''}${isFlagged ? ' (Flagged)' : ''}`}
            >
              {qNum}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionPalette;